import { render, staticRenderFns } from "./InformationAdmin.vue?vue&type=template&id=b4b43160&"
import script from "./InformationAdmin.vue?vue&type=script&lang=js&"
export * from "./InformationAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports